var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",style:(_vm.extraItem.extras('activityTheme.display') == 1 ||
    _vm.extraItem.extras('activityTime.display') == 1 ||
    _vm.extraItem.extras('activityPlace.display') == 1 ||
    _vm.extraItem.extras('activitySchedule.display') == 1 ||
    _vm.platform == 'wap'
      ? ''
      : 'width:80%')},[_c('div',{staticClass:"u-success",style:({
      display: _vm.extraItem.extras('refuseImg.display') == 0 ? 'none' : 'block',
    })},[_c('img',{attrs:{"src":_vm.extraItem.extras('refuseImg.src'),"alt":""}})]),_c('div',{staticClass:"t-success",style:({
      color: _vm.extraItem.extras('refuseTitle.color'),
      fontSize: _vm.pxOrVw(_vm.extraItem.extras('refuseTitle.size')),
      fontWeight:
        _vm.extraItem.extras('refuseTitle.weight') == 'default'
          ? '500'
          : _vm.extraItem.extras('refuseTitle.weight'),
      display:
        _vm.extraItem.extras('refuseTitle.display') == 0 ? 'none' : 'block',
    })},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"refuseTitle.model"))+" ")]),_c('div',{staticClass:"t-success-desc",style:({
      color: _vm.extraItem.extras('refuseText.color'),
      fontSize: _vm.pxOrVw(_vm.extraItem.extras('refuseText.size')),
      fontWeight:
        _vm.extraItem.extras('refuseText.weight') == 'default'
          ? '400'
          : _vm.extraItem.extras('refuseText.weight'),
      display: _vm.extraItem.extras('refuseText.display') == 0 ? 'none' : 'block',
    })},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"refuseText.model"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }